import React, { Component } from 'react';
import asyncComponent from '../../helpers/AsyncFunc';
import Route from '../../components/utility/customRoute';
import { Redirect } from 'react-router-dom';

/* This is a BAD hack to deal with a malformed URL from the API */
const DoRedirect = props => {
	const { hash } = props.match.params;
	const refHash = hash.split("&")[0];
	const redirectpath = `/external/referencetenant/${refHash}/TenantRequestLandlordReference`;
	return <Redirect to={redirectpath} />
}

const routes = [
	{
		path: '',
		component: asyncComponent(() => import('../blankPage')),
	},
	{
		path: 'tenantreferencing/:hash',
		component: (props) => <DoRedirect {...props} />,
	},
	{
		path: 'referencetenant/:hash/:type',
		component: asyncComponent(() => import('../Tenants/referenceTenant')),
	},
	{
		path: 'verifyrentpayment/:vhash',
		component: asyncComponent(() => import('../Tenants/verifyRentPayment')),
	},
];


class AppRouter extends Component {
	render() {
		const { url, style } = this.props;
		return (
			<div style={style}>
				{routes.map(singleRoute => {
					const { path, exact, ...otherProps } = singleRoute;
					return (
						<Route
							exact={exact === false ? false : true}
							key={singleRoute.path}
							path={`${url}/${singleRoute.path}`}
							{...otherProps}
						/>
					);
				})}
			</div>
		);
	}
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/containers/AppNoAuth/appRouter.js